import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { isMobile } from 'react-device-detect';
import { Icon } from '@iconify/react';
import { Link, useNavigation } from 'react-router-dom';
import { Tooltip as ReactTooltip } from "react-tooltip";

// Components
import Header from "../../components/Header";
import Banner from "../../components/Home/Banner";
import Destaques from "../../components/Home/Destaques";
import Blindados from "../../components/Home/Blindados";
import ExperienciaPersonalizada from "../../components/Home/ExperienciaPersonalizada";
import NossosServicos from "../../components/Home/NossosServicos";
import Numeros from "../../components/Home/Numeros";
import Depoimentos from "../../components/Home/Depoimentos";
import Footer from "../../components/Home/Footer";
import Menu from "../../components/Home/Menu";

// imagens
import img404 from "../../pages/Page404/img/404.png";

// Styles
import './Page404.scss';
import 'react-tooltip/dist/react-tooltip.css'
import { useNavigationIdz } from '../../context/useNavigation';


function Page404() {

    const { navigation, idzOrigin, idzEvent, loading } = useNavigationIdz()
    useEffect(() => {
        if (!loading) {
            idzOrigin(window.location.href)
            idzEvent("paginas_acessadas", "404 Not Found")
        } 
    }, [loading])

    return (
        <>
            <Menu />
            <Header />
            <section className='Page404'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col xs={12} sm={6} md={6} lg={6}>
                            <img src={img404} />
                            <h3>opa</h3>
                            <h4>erro 404</h4>
                            <p>Parece que algo deu errado. Mas não se preocupe, veja abaixo algumas opções que você pode gostar.</p>
                        </Col>
                    </Row>
                </Container>
            </section>
            <NossosServicos />
            <Footer />
        </>

    );
}

export default Page404;
